import { Activity, Radio, Gift, Framer, BarChart2 } from 'react-feather'

export default [
  // {
  //   id: 'eth-fan-efbp',
  //   title: 'EFBP',
  //   icon: <Radio size={20} />,
  //   navLink: '/eth-fan-efbp'
  // },
  {
    id: 'eth-fan-v2',
    title: 'ETH Fan V2',
    icon: <Gift size={20} />,
    navLink: '/eth-fan-v2'
  },
  {
    id: 'eth-fan-burn',
    title: 'ETH FAN BURN',
    icon: <Framer size={20} />,
    navLink: '/eth-fan-burn'
  },
  // {
  //   id: 'calculator',
  //   title: 'Calculator V1',
  //   icon: <Activity size={20} />,
  //   navLink: '/rewasaaaaaaaaaaads-calculator-v1'
  // },
  {
    id: 'calculator-v2',
    title: 'ETH Fan V2 Calculator',
    icon: <BarChart2 size={20} />,
    navLink: '/eth-fan-calculator-v2'
  }
]
